/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OCRPatientId
 */
export interface OCRPatientId {
    /**
     * 
     * @type {number}
     * @memberof OCRPatientId
     */
    page?: number;
    /**
     * 
     * @type {string}
     * @memberof OCRPatientId
     */
    id?: string;
}

/**
 * Check if a given object implements the OCRPatientId interface.
 */
export function instanceOfOCRPatientId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OCRPatientIdFromJSON(json: any): OCRPatientId {
    return OCRPatientIdFromJSONTyped(json, false);
}

export function OCRPatientIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): OCRPatientId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function OCRPatientIdToJSON(value?: OCRPatientId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'id': value.id,
    };
}

